import React, { lazy, Suspense} from "react";
import "../src/App.css";
import Navbar from "./components/Navbar/Navbar";
const Body = lazy(() => import("./components/Body/Body"));
const Footer = lazy(() => import("./components/Footer/index"));
const imgCDNURL = process.env.REACT_APP_CDN_IMAGES;
function App() {
   
  return (   
        
      <div className="bodyContainer">
        <div>
               <video
                  width="100%"
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="banner-video"
                  fetchpriority="high"
                >
                  <source
                    src={imgCDNURL + "banner-bg-desktop-v2.mp4"}
                    type="video/mp4"
                  />
                </video>
                <Navbar fetchpriority="high" />
                </div>
            <Suspense fallback={<div />}>
              <Body fetchpriority="highest"/>
            </Suspense>    
            <Suspense fallback={<div />}>
              <hr className="footerLine" />
              <div>
                <Footer />
              </div>
            </Suspense>    
      </div>  
  );
}

export default App;
